import { render } from "./OldSite.vue?vue&type=template&id=16ee3e55"
import script from "./OldSite.vue?vue&type=script&lang=js"
export * from "./OldSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__